import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  UTILISATION_DASHBOARD_TYPE_SOL,
  UTILISATION_DASHBOARD_TYPE_ACTIVITY,
} from "../../../constants/general-constants";
import { useHistory } from "react-router-dom";

export default function UtilisationOrganisationNavigatorTab({
  spaceTypeId,
  selectedParentSpaceTypeId,
  dashboardType,
  color,
  label,
  icon,
}) {
  const [isActive, setIsActive] = useState(false);
  const [isHover, setIsHover] = useState(false);

  const history = useHistory();

  // -----------------------------
  // ACTIVE STATE
  // -----------------------------
  useEffect(() => {
    setIsActive(parseInt(spaceTypeId) === parseInt(selectedParentSpaceTypeId));
  }, [spaceTypeId, selectedParentSpaceTypeId]);

  // -----------------------------
  // STYLES
  // -----------------------------
  const organisationTab = {
    cursor: "pointer",
    display: "flex",
    width: "calc(20% - 10px)",
    height: "42px",
    alignItems: "center",
    justifyContent: "center",

    // 🔥 LIGHT CARD STYLE (matches your UI)
    background: isActive
      ? "linear-gradient(180deg, #ffffff 0%, #f4f6f9 100%)"
      : "transparent",

    borderRadius: "0px",

    boxShadow: isActive
      ? "0 1px 2px rgba(0,0,0,0.05)"
      : isHover
      ? "0 4px 10px rgba(0,0,0,0.08)"
      : "none",

    transform: isHover && !isActive ? "scale(1.03)" : "scale(1)",

    transition: "all 0.2s ease",
    position: "relative",
  };

  const organisationIcon = {
    marginRight: "8px",
    width: "18px",
    height: "18px",

    // 🔥 KEEP BRAND COLOUR ALWAYS
    color: isActive ? color : isHover ? color : "#6b7280",

    transition: "all 0.2s ease",
  };

  const organisationTitle = {
    fontSize: "14px",
    fontWeight: isActive ? "600" : "500",
    color: isActive ? "#111" : isHover ? "#111" : "#6b7280",
    transition: "all 0.2s ease",
  };

  // 🔥 UNDERLINE INDICATOR
  const underline = isActive
    ? {
        position: "absolute",
        bottom: "-6px",
        left: "20%",
        width: "60%",
        height: "3px",
        borderRadius: "0px",
        background: color,
      }
    : null;

  // -----------------------------
  // CLICK HANDLER (UNCHANGED)
  // -----------------------------
  const handleOrganisationClick = () => {
    const basePath =
      dashboardType === UTILISATION_DASHBOARD_TYPE_SOL
        ? "/utilisationall/-100/"
        : "/utilisationallmeeting/-100/";

    history.push(basePath + spaceTypeId);
  };

  // -----------------------------
  // RENDER
  // -----------------------------
  return (
    <div
      style={organisationTab}
      onClick={handleOrganisationClick}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <FontAwesomeIcon icon={icon} style={organisationIcon} />
      <div style={organisationTitle}>{label}</div>

      {underline && <div style={underline}></div>}
    </div>
  );
}